import dayjs from "dayjs";

// The API is served from a different origin and its clock is the reference for
// every server-side timestamp (progress_at, modified_at, ...). The browser's own
// clock can be minutes off, which would skew any "how long ago" derived on the
// client. Each response carries an X-Server-Now header (epoch millis); we keep a
// running offset (localNow - serverNow) so serverNow() reports the server clock
// using only local elapsed time since the last sync. No absolute timestamp is
// ever compared across the two clocks.
let offsetMs = 0;

export function syncServerClock(serverNowMs) {
  const server = Number(serverNowMs);
  // A missing header reaches here as null, and Number(null) is a perfectly finite 0, which
  // would set the offset to the whole Unix epoch and date every timestamp on the site to 1970.
  if (!Number.isFinite(server) || server <= 0) return;
  offsetMs = Date.now() - server;
}

export function serverNow() {
  return dayjs(Date.now() - offsetMs);
}
